import { Editor, Node, Range, Element as SlateElement } from 'slate'

import { BLOCK_FORMATS } from '../../interface/custom-types'

import { TCustomElement } from './../../interface/custom-types'

const isEndOfLine = (editor: Editor, expandNode: TCustomElement) => {
  if (!editor.selection) {
    return
  }

  const expandStringLength = Node.string(expandNode).length
  const currentNodeRange = Range.end(editor.selection).offset

  if (expandStringLength === currentNodeRange) {
    return true
  }

  return false
}

export const deleteInsideExpandBlock = (editor: Editor) => {
  const [expandTitle] = Editor.nodes(editor, {
    match: (n) => SlateElement.isElement(n) && n.type === BLOCK_FORMATS.expandBlockTitle,
  })

  if (expandTitle) {
    return isEndOfLine(editor, expandTitle[0] as TCustomElement)
  } else {
    const [expandBlock] = Editor.nodes(editor, {
      match: (n) => SlateElement.isElement(n) && n.type === BLOCK_FORMATS.expandBlock,
    })

    if (expandBlock) {
      const expandParagraph = (expandBlock[0] as TCustomElement).children.find(
        (item) => (item as TCustomElement).type === BLOCK_FORMATS.paragraph
      )
      if (expandParagraph) {
        return isEndOfLine(editor, expandParagraph as TCustomElement)
      }
    }
  }

  return false
}
